export * from './terms-modal.component'
